define('shared/initializer/form/adapters/mixins/SubmissionLockable',['shared/lib/RSVP', 'shared/util/dom/form/disable', 'shared/util/dom/form/enable'], 
function ( RSVP, disable, enable ) {
    'use strict';

    function Ctor() { }

    Ctor.prototype.doSubmit = function( data ) {
        var me = this;
        var $form = me.$form;

        return RSVP.resolve()
            .then(function(){

                disable( $form );

                $form
                .one('form.submit.fail', function(){
                    enable( $form );
                });
            })
            .then(function(){
                return data;
            });
        
    };

    return Ctor;
});
